export default "### Flexible repayment terms\n\nPick the terms that suit you, with the option to reduce repayments.\n";